<template>
  <svg
    class="icon-arrow-right"
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.1457 1.00003L17 7.26967L10.1457 13.5393" stroke-miterlimit="10" stroke-linecap="round" />
    <path d="M16.0795 7.37033L1 7.37033" stroke-miterlimit="10" stroke-linecap="round" />
  </svg>
</template>

<style lang="scss">
.icon-arrow-right {
  display: block;
  stroke: var(--theme-icon-arrow-right-color);
  stroke-width: 2px;
}
</style>
